import { useEffectOnce } from 'react-use';

import { UnsignedMedicalInformationAttachmentCountQuery } from '@dreryk/egabinet-patient-medical-information-frontend-api';

import { useCqrsGet } from '@dreryk/command-query-react-common';
import { Badge, BadgeType } from '@dreryk/react-components';

import { registerRefetchUnsignedMedicalInformationAttachmentCountEventListener } from './RefetchUnsignedMedicalInformationAttachmentCount.events';

type UnsignedMedicalInformationAttachmentBadgeProps = {
   readonly patientId: number;
};

export const UnsignedMedicalInformationAttachmentBadge = ({
   patientId,
}: UnsignedMedicalInformationAttachmentBadgeProps): JSX.Element => {
   const {
      data: unsignedMedicalInformationAttachmentCount = 0,
      refetch: refetchUnsignedMedicalInformationAttachmentCount,
   } = useCqrsGet<number>(() => {
      const query = new UnsignedMedicalInformationAttachmentCountQuery();
      query.patientId = patientId;
      return query;
   });

   useEffectOnce(() =>
      registerRefetchUnsignedMedicalInformationAttachmentCountEventListener(
         refetchUnsignedMedicalInformationAttachmentCount
      )
   );

   return (
      <Badge
         testId={'unsignedMedicalInformationAttachmentCount'}
         type={BadgeType.NEGATIVE}
         count={unsignedMedicalInformationAttachmentCount}
         visible={Boolean(unsignedMedicalInformationAttachmentCount)}
      />
   );
};
